import { render } from "./Marketplace.html?vue&type=template&id=8bd197a6&external"
import script from "./Marketplace.js?vue&type=script&lang=js&external"
export * from "./Marketplace.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__